export function moviePlay() {
  const movieEle = document.querySelector('.js-movieEle');
  const movieEleMask = document.querySelector('.js-movieEleMask');
  const movieEleMain = document.querySelector('.js-movieEleMain');
  const IS_PLAY = 'is-play';

  if (document.querySelector('.js-movieEle')) {
    movieEle.addEventListener('click', () => {
      if (!movieEle.classList.contains(IS_PLAY)) {
        movieEle.classList.add(IS_PLAY);
        movieEleMask.remove();
        movieEleMain.play();
      }
    });
  }
}
